import api from '@/plugins/request/index';
// 获取项目详情
export const getProjectDetail = async (id, params, type = 'get') => {
  return api[type]('/gateway/v1/project/' + id, params).then(res => res);
}

// 添加项目
export const addProject = async (params, type = 'post') => {
  return api[type]('/gateway/v1/project/', params).then(res => res);
}
// 修改项目状态
export const editProjectStatus = async (id, type = 'put') => {
  return api[type]('/gateway/v1/project/' + id + '/change-status').then(res => res);
}
// 添加项目
export const editProject = async (id, params, type = 'put') => {
  return api[type]('/gateway/v1/project/' + id, params).then(res => res);
}
// 批量导入项目
export const importProjectBatch = async (params, type = 'post') => {
  return api[type]('/gateway/v1/project/import', params).then(res => res);
}
// 导出项目
export const exportProject = async (params, type = 'get') => {
  return api[type]('/gateway/v1/project/export', params).then(res => res);
} 
// 删除项目
export const deleteProject = async (id, type = 'delete') => {
  return api[type]('/gateway/v1/project/' + id).then(res => res);
} 